import script from "./CriticalTanksTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CriticalTanksTable.vue?vue&type=script&setup=true&lang=js"

import "./CriticalTanksTable.vue?vue&type=style&index=0&id=120d6f18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120d6f18"]])

export default __exports__